import { InjectionToken } from '@angular/core';

export const APP_DI_SETTINGS = new InjectionToken<IParameters>('AppSettingsParameters');

export interface IParameters {
    [key: string]: any;
}
